// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3496) return "static/chunks/3496-2b5159c6fda50ebb.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "ea5400140851bc3d" + ".js";
};